export const FLOATING_POINT_DIGIT=2
export const MAX_WIDTH=1400;